import React, { useState, useEffect } from 'react';

interface CollapseProps {
  in: boolean;
  children?: React.ReactNode;
  className?: string;
  timeout?: number | string;
  unmountOnExit?: boolean;
}

const Collapse: React.FC<CollapseProps> = ({
  in: isIn,
  children,
  className = '',
  timeout = 300,
  unmountOnExit = false,
}) => {
  const [isOpen, setIsOpen] = useState(isIn);
  const [isAnimating, setIsAnimating] = useState(false);
  const timeoutNum = typeof timeout === 'string' ? 300 : timeout;

  useEffect(() => {
    if (isIn) {
      setIsOpen(true);
      setIsAnimating(true);
      setTimeout(() => setIsAnimating(false), timeoutNum);
    } else {
      setIsAnimating(true);
      setTimeout(() => {
        setIsOpen(false);
        setIsAnimating(false);
      }, timeoutNum);
    }
  }, [isIn, timeoutNum]);

  if (unmountOnExit && !isOpen && !isAnimating) return null;

  return (
    <div
      className={`overflow-hidden transition-all ${isIn ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'} ${className}`}
      style={{ transitionDuration: `${timeoutNum}ms` }}
    >
      {children}
    </div>
  );
};

export default Collapse;

